import React, { FC, useEffect, useRef } from 'react';
import { useMerchant } from 'hooks/context/merchant';
import { useOrderResponseSummary } from '../OrderResponseSummary';
import { useSubmitOrder } from './SubmitOrder';
import { fromCents, toCents } from 'util/Formatting';
import {
  getIpgPaymentUrl,
  getIpgResponseFailURL,
  getIpgResponseSuccessURL,
  getIpgTransactionNotificationUrl
} from 'util/IpgPay';
import { IPG_PAYMENT_FORM_TEST_ID } from './IpgPaymentFormTestIds';
import { useOrderDetails } from '../OrderDetails';
import { useInvoiceSummary } from '../InvoiceSummary';

const IpgPaymentForm: FC<{estimatedTime: string}> = ({ estimatedTime }) => {
  const { merchant } = useMerchant();
  const { invoiceSummary } = useInvoiceSummary();
  const { orderResponse } = useOrderResponseSummary();
  const { setState } = useSubmitOrder();
  const { contactFormData: { customer } } = useOrderDetails();
  const ipgPaymentFormRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (orderResponse?.ipgInfo && ipgPaymentFormRef.current) {
      try {
        ipgPaymentFormRef.current.submit();
      } catch (e) {
        console.error(e);
        setState({ isOrderProcessing: false });
      }
    }
  }, [orderResponse, setState]);

  if (!orderResponse) return null;

  const { total, tipAmount, ipgInfo, receiptId } = orderResponse;

  if (!ipgInfo) return null;

  const { hash, storeId, txnDateTime, currencyCode } = ipgInfo;

  const formattedTotal = fromCents(total + tipAmount).toFixed(2);

  const formattedTotalTax = toCents(invoiceSummary?.tax ?? 0);

  return (
    <form ref={ipgPaymentFormRef} method="post" data-testid={IPG_PAYMENT_FORM_TEST_ID.root} action={getIpgPaymentUrl(process.env.NODE_ENV)}>
      <input type="hidden" aria-label="txntype" name="txntype" value="sale" />
      <input type="hidden" aria-label="timezone" name="timezone" value={merchant?.timezone} />
      <input type="hidden" aria-label="txndatetime" name="txndatetime" value={txnDateTime} />
      <input type="hidden" aria-label="hash_algorithm" name="hash_algorithm" value="SHA256" />
      <input type="hidden" aria-label="hash" name="hash" value={hash} />
      <input type="hidden" aria-label="storename" name="storename" value={storeId} />
      <input type="hidden" aria-label="chargetotal" name="chargetotal" value={formattedTotal} />
      <input type="hidden" aria-label="currency" name="currency" value={currencyCode} />
      <input type="hidden" aria-label="checkoutoption" name="checkoutoption" value="combinedpage" />
      <input type="hidden" aria-label="authenticateTransaction" name="authenticateTransaction" value="true" />
      <input type="hidden" aria-label="oid" name="oid" value={receiptId} />
      <input type="hidden" aria-label="merchantTransactionId" name="merchantTransactionId" value={receiptId} />
      <input type="hidden" aria-label="responseFailURL" name="responseFailURL" value={getIpgResponseFailURL(merchant?.slug)} />
      <input type="hidden" aria-label="responseSuccessURL" name="responseSuccessURL" value={getIpgResponseSuccessURL(receiptId, merchant?.slug, estimatedTime)} />
      <input type="hidden" aria-label="transactionNotificationURL" name="transactionNotificationURL" value={getIpgTransactionNotificationUrl(receiptId, merchant?.slug)} />
      <input type="hidden" aria-label="customParam_email" name="customParam_email" value={customer.email} />
      <input type="hidden" aria-label="customParam_totalTax" name="customParam_totalTax" value={formattedTotalTax} />
    </form>
  );
};

export { IpgPaymentForm };
